<template>
    <el-card class="box-card" v-loading="dataLoading">
        <div slot="header" class="clearfix">
            <span>
                <span class="el-icon-data-line"></span> 演出销售 
                <span class="color-info">
                    (销售额:<span class="color-danger">{{data && data.amountSum || 0}}</span> 
                    订单数:<span class="color-danger">{{data && data.orderNumSum || 0}}</span>)
                </span>
            </span>
            <router-link v-if="$utils.have('/sales/platform/list') && intervalData" class="fr color-theme" :to="`/report/sales/channel?timeStart=${intervalData.startTime} 00:00:00&timeEnd=${intervalData.endTime} 23:59:59`">
                查看详情<span class="el-icon-right"></span>
            </router-link>
        </div>
        <div class="content">
            <el-tabs v-model="activeName"  @tab-click="clickTab">
                <el-tab-pane label="销售额" name="1"></el-tab-pane>
                <el-tab-pane label="订单数" name="2"></el-tab-pane>
            </el-tabs>
            <div class="data-box">
                <el-row :gutter="20">
                    <el-col :sm="12" :lg="6">
                        <div v-for="(item,index) in categoryDataList" :key="index" class="category-item">
                            <el-image class="logo" :src="platforms.find( v => item.category == v.name ).logo">
                                <div slot="error" class="image-slot">
                                    <span class="el-icon-pie-chart"></span>
                                </div>
                            </el-image>
                            <!--销售-->
                            <div v-if="activeName == 1" class="info">
                                <div class="num">{{item.category}}销售: {{item.amount}}</div>
                                <div class="ratio color-info">环比: 
                                    <span v-if="item.amountRingRatio.type == 1" class="color-success"><span class="el-icon-top"></span> {{item.amountRingRatio.value}}</span>
                                    <span v-else class="color-danger"><span class="el-icon-bottom"></span> {{item.amountRingRatio.value}}</span>
                                </div>
                                <div class="avg color-info">日均: {{item.avgAmount}}</div>
                            </div>
                            <!--订单-->
                            <div v-else class="info">
                                <div class="num">{{item.category}}订单: {{item.totalNum}}</div>
                                <div class="ratio color-info">环比: 
                                    <span v-if="item.totalNumRingRatio.type == 1" class="color-success"><span class="el-icon-top"></span> {{item.totalNumRingRatio.value}}</span>
                                    <span v-else class="color-danger"><span class="el-icon-bottom"></span> {{item.totalNumRingRatio.value}}</span>
                                </div>
                                <div class="avg color-info">日均: {{item.avgTotalNum}}</div>
                            </div>
                        </div>    
                    </el-col>
                    <el-col :sm="12" :lg="6">
                        <div id="chartContainer1" ref="chartContainer1"></div>
                    </el-col>
                    <el-col :lg="12" >
                        <div id="chartContainer2" ref="chartContainer2"></div>
                    </el-col>
                </el-row>
            </div>
           
        </div>
    </el-card>
</template>

<script>
import xdLogo from '@/assets/img/dashboard/d-logo1.png';
import wyLogo from '@/assets/img/dashboard/d-logo2.png';
// import bdLogo from '@/assets/img/dashboard/d-logo3.png';
import txLogo from '@/assets/img/dashboard/d-logo4.png';
// import wkLogo from '@/assets/img/dashboard/d-logo5.png';
import dmLogo from '@/assets/img/dashboard/d-logo6.png';

import { Chart } from '@antv/g2';
export default {
    props:{
        intervalData:{
            type: Object,
            default: () => null
        },
        daterange: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            dataLoading: false,

            data: null,
            categoryDataList: [],
            
            activeName: "1",
            chart1: null,
            chart2: null,
        }
    },
    computed:{
        platforms() {
            return [
                {name: '秀动', logo: xdLogo},
                {name: '网易', logo: wyLogo},
                // {name: '百度', logo: bdLogo},
                {name: '腾讯', logo: txLogo},
                // {name: '文客', logo: wkLogo},
                {name: '大麦', logo: dmLogo},
                {name: '其他', logo: ''},
            ]
        }
    },
    mounted(){
        this.getData();
    },
    watch:{
        intervalData(v1,v2){
            if(v1 && v1 != v2){
                this.getData();
            }
        }
    },
    methods:{
        getData(){
            this.dataLoading = true;
            this.$request({
                url: "/dashboard/activitySales",
                method: "POST",
                data: {
                    timeInterval: this.intervalData.timeInterval || "",
                    start: this.daterange.length > 0 ? this.daterange[0]: "",
                    end: this.daterange.length > 1 ? this.daterange[1]: "",
                    platforms: this.platforms.map(v => v.name)
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.categoryDataList = result.categoryDataList;

                        this.$nextTick(() => {
                            this.drawChart1();
                            this.drawChart2();
                        })
                        
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        clickTab(){
            this.drawChart1();
            this.drawChart2();
        },
        drawChart1(){
            if( this.chart1 ) this.chart1.destroy();
            let _data = [];
            if( this.activeName == 1 ){
                _data = [...this.data.amountChart.pieSeriesData];
                _data.map( v => {
                    v.percent = parseFloat((v.value / this.data.amountSum).toFixed(4));
                })
            }else{
                _data = [...this.data.orderNumChart.pieSeriesData];
                _data.map( v => {
                    v.percent = parseFloat((v.value / this.data.orderNumSum).toFixed(4));
                })
            }

            _data = _data.filter( v => v.value > 0 );
            
            this.chart1 = new Chart({
                container: 'chartContainer1',
                autoFit: true,
                height: 420,
            });

            this.chart1.coordinate('theta', {
                radius: 0.75,
            });

            this.chart1.data(_data);

            this.chart1.scale('percent', {
                formatter: (val) => {
                    val = (val * 100).toFixed(2) + '%';
                    return val;
                },
            });

            this.chart1.tooltip({
                showTitle: false,
                showMarkers: false,
            });

            this.chart1.legend('name', {
                position: 'top',
            });
            
            this.chart1
                .interval()
                .adjust('stack')
                .position('percent')
                .color('name')
                .label('percent', () => {
                    return {
                        content: (obj) => {
                            return obj.name;
                        },
                    };
                })
                .tooltip('name*value*percent', (name, value, percent) => {
                    percent = (percent * 100).toFixed(2) + '%';
                    return {
                        name: name,
                        value: value+'('+percent+')',
                    };
                });

            this.chart1.render();

        },
        drawChart2(){
            if( this.chart2 ) this.chart2.destroy();
            let _data = [];
            const _dataArry = this.activeName == 1 ? [...this.data.amountChart.lineSeriesData] : [...this.data.orderNumChart.lineSeriesData];

            _dataArry.map( item => {
                item.value.map( v => {
                    _data.push({
                        name: item.name,
                        year: v.name,
                        value: parseFloat(v.value)
                    })
                })
            })
            
            this.chart2 = new Chart({
                container: 'chartContainer2',
                autoFit: true,
                height: 420,
            });
            this.chart2.data(_data);

            if( this.data.amountChart.lineSeriesData[0].value.length > 7 ){
                this.chart2.option('slider', {
                    start: (this.data.amountChart.lineSeriesData[0].value.length - 7) / this.data.amountChart.lineSeriesData[0].value.length,
                    end: 1,
                });
            }

            this.chart2.tooltip({
                showCrosshairs: true,
                shared: true,
            });
            this.chart2.legend('name', {
                position: 'top',
            });
            this.chart2
                .line()
                .position('year*value')
                .color('name')
                .shape('smooth')
                .tooltip('name*value', (name, value) => {
                    value = this.activeName == 1 ? parseFloat(value).toFixed(2) : value;
                    return {
                        name: name,
                        value: value,
                    };
                });
            // this.chart2
            //     .point()
            //     .position('year*value')
            //     .color('name')
            //     .shape('circle');

            this.chart2.render();
        }
    }
}
</script>

<style lang="scss" scoped>
.content{
    .category-item{
        display: flex;
        align-items: center;
        margin: 10px 0;
        border: 1px #eee solid;
        padding: 10px;
        font-size: 12px;
        border-radius: 4px;
        .el-image{
            margin-right: 10px;
            width: 46px;
            ::v-deep .image-slot{
                background: none;
                font-size: 46px;
                color: $--color-theme;
            }
        }
        .info{
            flex: 1;
            .num{
                font-size: 14px;
            }
        }
    }
}
</style>